export default __webpack_public_path__ + "static/media/mousse.140151a9.png";